<template>
  <div class="TraineeManagement">
    <AppHeader>学员管理</AppHeader>
    <AppBox class="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="">
            <el-input
                v-model="filter.keyword"
                placeholder="姓名|手机号码"
                @keyup.enter.native="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item label="上次登录">
            <date-select ref="dateSelect" @pick="handleTimePick"></date-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <input
            type="file"
            ref="fileInput"
            style="display: none"
            @change="handleFileChange"
          />
          <el-button type="primary" plain @click="handleAddTrainee"
                     v-show="permissionCode.has('admin:trainee:manager')"
          >新增学员
          </el-button>
          
          <el-button
              type="primary"
              native-type="submit"
              plain
              @click="openFilePicker" v-show="permissionCode.has('admin:user:manager')"
          >导入学员
          </el-button>
          <el-button
              type="primary"
              native-type="submit"
              plain
              @click="handleDownLoad" v-show="permissionCode.has('admin:user:manager')"
          >下载模板
          </el-button>
        </div>
      </div>
      <TraineeList ref="traineeList"></TraineeList>
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import TraineeList from "@/pages/TraineeManagement/TraineeList.vue";
import DateSelect from "@/components/dateSelect/index.vue";
import administrativeCenter from "../../api/administrativeCenter";

export default {
  name: "TraineeManagement",
  components: {DateSelect, TraineeList, AppHeader, AppBox},
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.administrativeCenter
            .tenantTraineeFilter;
      },
      set(value) {
        this.$store.commit("administrativeCenter/setData", {
          key: "tenantTraineeFilter",
          value,
        });
      },
    },
  },
  async mounted() {
    this.$refs.dateSelect.dateRange=[]
  },
  methods: {
    ...mapActions("administrativeCenter", [
      "getTenantDepartmentUser",
      "getTenantTraineeList",
      "importDepartmentUser"
    ]),
    ...mapMutations("administrativeCenter", ["clearFilter"]),
    handleTimePick(date) {
      if (date && date.length === 2) {
        this.filter.startTime = date[0];
        this.filter.endTime = date[1];
      } else {
        this.filter.startTime = this.filter.endTime = null;
      }
      this.onSubmit();
    },
    // 搜索
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getTenantTraineeList({page: 1});
        }
      });
    },
    //重置
    onReset() {
      this.clearFilter();
      this.$refs.dateSelect.dateRange = [];
      this.filter.startTime = this.filter.endTime = null;
      this.getTenantTraineeList({page: 1});
    },
    // 新增人员
    async handleAddTrainee() {
      this.$refs.traineeList.$refs.addTrainee.initData();
    },
    openFilePicker() {
      // 点击按钮时触发 input[type="file"] 的点击事件
      this.$refs.fileInput.click();
    },
    // 下载模板
    handleDownLoad() {
      var eleLink = document.createElement("a");
      eleLink.download = "用户信息模板";
      eleLink.style.display = "none";

      // 字符内容转变成blob地址
      eleLink.href = administrativeCenter.getDownloadTemplateUrl();
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    async handleFileChange(event) {
      let file = event.target.files[0];
      // 处理选择的文件
      if (file.name.endsWith(".xls") || file.name.endsWith(".xlsx")) {
        const data = new FormData();
        data.append("file", file);
        await this.importDepartmentUser(data);
        await this.getTenantDepartmentUser({});
        this.$message.warning("导入成功");
      } else {
        this.$message.warning("请选择Excel文件进行导入");
      }
      file = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.TraineeManagement {
  .appBox {
    min-height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;
    }
  }
}
</style>
